module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGfc02edf2c2ddb79d91562cebeeb65698.fc02edf2.png";